// extracted by mini-css-extract-plugin
export default {"info-container":"style_info-container__+aRMB"};